// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
Vue.config.productionTip = false
//UI mint-ui
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)
//ajax vue-resource
import VueResource from 'vue-resource'
Vue.use(VueResource)
//国际化
import VueI18n from 'vue-i18n'
import {showMsg} from "./tools/other";
Vue.use(VueI18n);
const i18n = store.state.i18n = new VueI18n({
  locale: 'en',    // 语言标识
  messages: {
    'zh': require('./assets/common/lang/zh'),   // 中文语言包
    'en': require('./assets/common/lang/en')    // 英文语言包
  },
})
//全局异常捕获
/**
 * @param {String} errorMessage  错误信息
 * @param {String} scriptURI   出错的文件
 * @param {Long}  lineNumber   出错代码的行号
 * @param {Long}  columnNumber  出错代码的列号
 * @param {Object} errorObj    错误的详细信息，Anything
 */
window.onerror = function(errorMessage, scriptURI, lineNumber,columnNumber,errorObj) {
  // TODO
  console.log('errorMessage',errorMessage)
  showMsg(errorMessage,'bottom',8000)
}

// import * as fundebug from "fundebug-javascript";
// import fundebugVue from "fundebug-vue";
// fundebug.apikey = "3e622d21df0ae33cff336b4bffaca0695cf67dca7b16aee17c23c480de08866d"
// fundebugVue(fundebug, Vue);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js